module.exports = __webpack_public_path__ + "img/chanpin@2x.fedf40d3.png";